
const STORAGE_KEY = "transfer.prices_grid_filters"
const PREFIX = "tp_"
const Q_PARAM = `${PREFIX}q`
const PAGE_PARAM = `${PREFIX}page`
const PER_PARAM = `${PREFIX}per`

const safeParse = (str) => {
  if (!str) return null
  try {
    return JSON.parse(str)
  } catch {
    return null
  }
}

// state -> плоский объект строк (только не-дефолтные значения)
const serialize = ({ filters, q, page, per }, { defaultFilters, defaultPer }) => {
  const out = {}

  Object.keys(defaultFilters).forEach((k) => {
    const v = filters[k]
    if (v !== undefined && v !== null && String(v) !== String(defaultFilters[k])) {
      out[`${PREFIX}${k}`] = String(v)
    }
  })

  if (q && q.trim()) out[Q_PARAM] = q
  if (page > 1) out[PAGE_PARAM] = String(page)
  if (per && per !== defaultPer) out[PER_PARAM] = String(per)

  return out
}

const deserialize = (raw, { defaultFilters, perOptions, defaultPer }) => {
  const filters = { ...defaultFilters }
  Object.keys(defaultFilters).forEach((k) => {
    const v = raw[`${PREFIX}${k}`]
    if (typeof v === "string") filters[k] = v
  })

  const page = parseInt(raw[PAGE_PARAM], 10)
  const per = parseInt(raw[PER_PARAM], 10)

  return {
    filters,
    q: typeof raw[Q_PARAM] === "string" ? raw[Q_PARAM] : "",
    page: page > 0 ? page : 1,
    per: perOptions.includes(per) ? per : defaultPer,
  }
}

export const loadGridState = (config) => {
  let raw = null

  try {
    const sp = new URLSearchParams(window.location.search)
    const keys = [...sp.keys()].filter((k) => k.startsWith(PREFIX))
    if (keys.length) {
      raw = {}
      keys.forEach((k) => {
        raw[k] = sp.get(k)
      })
    }
  } catch {
    // ignore
  }

  if (!raw) {
    try {
      raw = safeParse(window.localStorage.getItem(STORAGE_KEY))
    } catch {
      raw = null
    }
  }

  return deserialize(raw || {}, config)
}

export const saveGridState = (state, config) => {
  const out = serialize(state, config)

  try {
    const url = new URL(window.location.href)
    ;[...url.searchParams.keys()]
      .filter((k) => k.startsWith(PREFIX))
      .forEach((k) => url.searchParams.delete(k))
    Object.entries(out).forEach(([k, v]) => url.searchParams.set(k, v))
    window.history.replaceState(window.history.state, "", url.toString())
  } catch {
    // ignore
  }

  try {
    const { [PAGE_PARAM]: _page, ...forStorage } = out
    if (Object.keys(forStorage).length) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(forStorage))
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    // ignore
  }
}
